import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const IndustryClient = () => {
  return (
    <SettingsMetaData propertyName={"industry"} viewPropertyName={"Industry"} />
  );
};
export default IndustryClient;